import {useTranslation} from 'react-i18next';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';
import type {TargetProfileAlignmentAssessmentScope} from '../../types/WorkforceProfileTypes';

type Props = {
  assessmentScope: TargetProfileAlignmentAssessmentScope;
};

export const WorkforceProfileAlignmentAssessmentScopeNote = ({assessmentScope}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.detail.assessmentScope'});

  if (!assessmentScope.representative) {
    return null;
  }

  return (
    <Box
      role='note'
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.25,
        mb: 2,
        p: 1.75,
        borderRadius: '12px',
        border: `1px solid ${orangeColors[3]}`,
        bgcolor: 'background.paper',
      }}
    >
      <InfoOutlinedIcon sx={{fontSize: 20, color: 'text.secondary', mt: 0.125}} aria-hidden />
      <Typography variant='body2' color='text.secondary' sx={{lineHeight: 1.6}}>
        {t('representativeNote', {
          assessed: assessmentScope.skillsInScope,
          total: assessmentScope.skillsTotal,
        })}
      </Typography>
    </Box>
  );
};
